<template>
  <b-field :label="label">
    <b-autocomplete
      :value="fonction"
      @typing="(txt) => fonction = txt"
      @select="option => fonction = option.libelle"
      :data="filteredFonctionsContact"
      :open-on-focus="true"
      icon="magnify">
      <template slot="empty">
        {{$t('general.autocomplete.noRslt')}}
      </template>
      <template slot-scope="props">
        {{ props.option.libelle }}
      </template>
    </b-autocomplete>
  </b-field>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'fonction-selection',
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    fonction: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    fonctionsContact() {
      return this.parametre(PARAMETRES_KEYS.fonctionContact);
    },
    filteredFonctionsContact() {
      return this.fonctionsContact
        .filter(f => f.actif && f.libelle?.toLowerCase()
          .includes(this.fonction.toLowerCase()));
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.fonctionContact]);
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
